import PurchaseBusinessService from '../../purchase-business-service';
import Service from '@/service/index.js';
import { isPurchaseTypeFlag } from '@/utils/common.js';
export default {
  data() {
    return {
      activeNav: 1,
      detail: {
        signInfo: {}
      },
      signApproveStatus: [],
      paymentMethod: [],
      signFiles: [],
      fileInfo: {},
      marginInfo: {},
      criminalRecord: '',
      promiseEnterprise: '',
      barry: [],
      fileSign: []
    };
  },
  created () {
    Service.getSelectList('SIGN_PEOPLE_BID_FILE_TYPE').then(res => {
      if (res && res.code === '0') {
        const arr = res.data.sort((a, b) => a.sort - b.sort).slice(0, 3);
        this.initFile(arr, res.data);
        this.barry = res.data;
      }
    });
    Service.getSelectList('PURCHASE_SIGN_APPROVE_STATUS').then(res => {
      if (res && res.code === '0') {
        this.signApproveStatus = res.data;
      }
    });
    Service.getSelectList('PURCHASE_PAYMENT_METHOD').then(res => {
      if (res && res.code === '0') {
        this.paymentMethod = res.data;
      }
    });
    this.id = this.$route.query.id;
    if (this.id) {
      this.getSignUpPurchaseDetail();
    }
  },
  methods: {
    isPurchaseTypeFlag,
    changeActiveNav (key) {
      this.activeNav = key;
    },
    initFile (arr, brr) {
      arr.forEach(item => {
        this.signFiles.push({
          projectFileType: Number(item.code),
          title: item.value,
          filePaths: []
        });
      });
      this.signFiles.splice(1, 0, {
        projectFileType: brr[5] && Number(brr[5].code),
        title: brr[5] && brr[5].value,
        filePaths: [],
        description: brr[5] && brr[5].description,
        inputValue: null
      });
      // this.signFiles.splice(2, 0, {
      //   projectFileType: brr[6] && Number(brr[6].code),
      //   title: brr[6] && brr[6].value,
      //   filePaths: [],
      //   description: brr[6] && brr[6].description,
      //   inputValue: null
      // });
    },
    getSignUpPurchaseDetail() {
      PurchaseBusinessService.getSignUpPurchaseDetail(this.id).then(res => {
        if (res && res.code === '0') {
          this.detail = res && res.data;
          this.criminalRecord = res.data.criminalRecord;
          this.promiseEnterprise = res.data.promiseEnterprise;
          // 犯罪记录类型
          // console.log(this.criminalRecord, this.promiseEnterprise, this.detail);
          let brr = this.barry;
          if((Number(this.criminalRecord) === 1)) {
            this.signFiles.splice(2, 0, {
              projectFileType: brr[6] && Number(brr[6].code),
              title: brr[6] && brr[6].value,
              filePaths: [],
              description: brr[6] && brr[6].description,
              inputValue: null
            });
          } else if(Number(this.criminalRecord) === 2){
            this.signFiles.splice(2, 0, {
              projectFileType: brr[7] && Number(brr[7].code),
              title: brr[7] && brr[7].value,
              filePaths: [],
              description: brr[7] && brr[7].description,
              inputValue: null
            });
          }
          //  失信企业名单类型
          if(Number(this.promiseEnterprise) === 1) {
            this.signFiles.splice(3, 0, {
              projectFileType: brr[8] && Number(brr[8].code),
              title: brr[8] && brr[8].value,
              filePaths: [],
              description: brr[8] && brr[8].description,
              inputValue: null
            });
          } else if(Number(this.promiseEnterprise) === 1) {
            this.signFiles.splice(3, 0, {
              projectFileType: brr[9] && Number(brr[9].code),
              title: brr[9] && brr[9].value,
              filePaths: [],
              description: brr[9] && brr[9].description,
              inputValue: null
            });
          }
          if (res && res.data && res.data.fileInfos && res.data.fileInfos.length) {
            this.signFiles.forEach(item => {
              const obj = res.data.fileInfos.find(v => v.projectFileType === item.projectFileType);
              if (!obj) {
                return;
              }
              console.log(res.data, 'item');
              item.filePaths = obj.filePaths.map(v => v.allPath);
            });
            res.data && res.data.fileInfos.forEach(item => {
              if(Number(item.projectFileType) === 5) {
                console.log(this.fileSign, 'this.fileSign');
                this.fileSign = item.filePaths[0];
              }
            });
          }
          if (res && res.data && res.data.transactionInfos && res.data.transactionInfos.length) {
            this.fileInfo = res.data.transactionInfos.find(item => item.transactionType === 4) || {};
            this.marginInfo = res.data.transactionInfos.find(item => item.transactionType === 2) || {};
          }
        }
      });
    },
    previousStep () {
      this.$router.back();
    },
    // 下载文件
    download(file) {
      window.location = file;
    }
  }
};
